import { createReducer, on } from '@ngrx/store';
import { CommandProgressApiActions, CommandProgressSignalRActions } from './command-progress.actions';
import { adapter, initialState } from './command-progress.state';

export const commandProgressFeatureKey = 'command-progress';

export const commandProgressReducer = createReducer(
  initialState,
  on(CommandProgressApiActions.commandProgressLoaded, (state, { commandProgresses }) =>
    adapter.upsertMany(commandProgresses, state)
  ),
  on(CommandProgressSignalRActions.commandProgressReceived, (state, { commandProgress }) =>
    adapter.upsertOne(commandProgress, state)
  ),
  on(CommandProgressApiActions.commandQueued, (state, { commandProgress }) => adapter.upsertOne(commandProgress, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCommandProgressIds = selectIds;
export const selectCommandProgressEntities = selectEntities;
export const selectAllCommandProgress = selectAll;
